module.exports = __webpack_public_path__ + "media/images/svg/robles_sphere-246cf3297629df1a2c2dbfb7c6c18a19.svg";